import { apiFetch } from 'integrations/crossborderit/fetch';
import { apiFetchFormData } from 'integrations/crossborderit/fetchFormData';

export const useCrossborderitApi = () => ({
  api: apiFetch,
  apiFormData: apiFetchFormData,
});
